import { Select, Space, Table } from "antd";
import { useTranslation } from "react-i18next";
import { ColumnsType } from "antd/es/table";
import { useGetStudentsSpecialityAndCourseQuery } from "src/app/services/tables";
import { IStudentTableSpecialityAndCourse } from "src/app/services/tables/type";
import { useState } from "react";
import { tablePaginationConfigTwo } from "src/app/services/api/const";
import { useColumnSearch } from "src/pages/higher_education/tables/useColumnSearch";
import { DownloadButton } from "src/components/downloadButton";
import {
  useGetAllUniversitiesQuery,
  useGetGenderQuery,
} from "src/app/services/private";

export function TableStudentsSpecialityAndCourse() {
  const { t } = useTranslation();

  const getColumnSearchProps = useColumnSearch();
  const [gender, setGender] = useState<string>();
  const [univerCode, setUniverCode] = useState<string>();
  const [eduTypeCode, setEduTypeCode] = useState<number>(11);
  const { data: students, isFetching } = useGetStudentsSpecialityAndCourseQuery(
    {
      gender,
      eduTypeCode,
      univerCode,
    },
  );

  const { data: genderList } = useGetGenderQuery();
  const { data: universitiesList } = useGetAllUniversitiesQuery();

  const columns: ColumnsType<IStudentTableSpecialityAndCourse> = [
    {
      title: t("tables.speciality_code"),
      dataIndex: "specialityCode",
      align: "center",
    },
    {
      title: t("tables.speciality"),
      dataIndex: "speciality",
    },
    {
      title: t("courses.course_1"),
      dataIndex: "firstCourseCount",
      align: "center",
    },
    {
      title: t("courses.course_2"),
      dataIndex: "secondCourseCount",
      align: "center",
    },
    {
      title: t("courses.course_3"),
      dataIndex: "thirdCourseCount",
      align: "center",
    },
    {
      title: t("courses.course_4"),
      dataIndex: "fourthCourseCount",
      align: "center",
    },
    eduTypeCode === 11
      ? {
          title: t("courses.course_5"),
          dataIndex: "fifthCourseCount",
          align: "center",
        }
      : {
          hidden: true,
        },
    eduTypeCode === 11
      ? {
          title: t("courses.course_6"),
          dataIndex: "sixthCourseCount",
          align: "center",
        }
      : {
          hidden: true,
        },
    {
      title: t("tables.total"),
      dataIndex: "total",
      align: "center",
      render: (total) => <b>{total}</b>,
    },
  ];

  const edu_type_list = [
    {
      value: 11,
      label: "Bakalavr",
    },
    {
      value: 12,
      label: "Magistr",
    },
  ];

  return (
    <div className="doctoralOrganization">
      <Table
        title={() => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3>{t("tables.count_students_direction_and_course")}</h3>

            <Space>
              <Select
                style={{ width: 230 }}
                placeholder="Jinsi bo'yicha"
                onChange={setGender}
                allowClear
                onClear={() => setGender(undefined)}
                options={genderList?.map((item) => ({
                  label: item.name,
                  value: item.code,
                }))}
              />

              <Select
                style={{ width: 230 }}
                placeholder="Universitet bo'yicha"
                onChange={setUniverCode}
                allowClear
                showSearch={true}
                filterOption={true}
                optionFilterProp="label"
                onClear={() => setUniverCode(undefined)}
                options={universitiesList?.map((item) => ({
                  label: item.univerName,
                  value: item.univerCode,
                }))}
              />

              <Select
                style={{ width: 230 }}
                onChange={setEduTypeCode}
                value={eduTypeCode}
                options={edu_type_list}
              />

              <DownloadButton
                downloadUrl="/statistic/excel/student/speciality/eduTypeAndCourse"
                params={{
                  gender,
                  eduTypeCode,
                  univerCode,
                }}
              />
            </Space>
          </div>
        )}
        rowKey="speciality"
        dataSource={students}
        columns={columns}
        pagination={{
          ...tablePaginationConfigTwo,
          total: students?.length,
          showTotal: (total) => `Jami ${total} ta`,
        }}
        size="small"
        scroll={{ x: true }}
        loading={isFetching}
      />
    </div>
  );
}
